import type { ISignallerFormState } from '../../components/signallerForm/signallerForm.type';

export const getConfirmType = (
  { password, email }: ISignallerFormState,
  showPassword: boolean,
): '' | 'confirm' | 'confirmSignaller' | 'confirmPass' => {
  const noPassword = password === '';
  const noEmail = email === '';

  if (noEmail && noPassword && showPassword) {
    return 'confirm';
  }

  if (noEmail) {
    return 'confirmSignaller';
  }

  if (noPassword && showPassword) {
    return 'confirmPass';
  }

  return '';
};
